const SecurityPage = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-white">Security</h1>
      <p className="text-gray-400 mt-2">Security settings content</p>
    </div>
  );
};
export default SecurityPage;